module.exports = __webpack_public_path__ + "img/home-arrows-up.c7491e7c.svg";